import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';

const CalculationLayoutContainer = ({ children, ...props }) => (
  <Box textAlign="center" {...props}>
    {children}
  </Box>
);

CalculationLayoutContainer.propTypes = {
  children: PropTypes.node,
};

CalculationLayoutContainer.defaultProps = {
  children: null,
};

export default CalculationLayoutContainer;
